/** Kualoa Beach House brand palette — single source for JS/API contexts (Stripe, Recharts, inline styles). */
export const PALM_GREEN = "#2F5E34"; // palm green accent
export const INK_GREEN = "#17311C"; // deep palm ink

/** @deprecated Legacy aliases from the pre-2026 bronze brand. Use PALM_GREEN / INK_GREEN. */
export const BRONZE_600 = PALM_GREEN;
/** @deprecated Legacy alias — use INK_GREEN. */
export const BRONZE_700 = INK_GREEN;
